// src/utils/highlightDom.js

/**
 * Scroll to the element with this id and flash it briefly.
 * @param {string} paragraphID
 * @returns {boolean} true if element found
 */
export function jumpToParagraph(paragraphID) {
  if (!paragraphID) return false
  const el = document.getElementById(paragraphID)
  if (!el) return false
  try {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    flash(el)
    return true
  } catch {
    return false
  }
}

/**
 * Add a temporary outline/flash to the element.
 * Removes itself after ~1.2s.
 */
export function flash(el) {
  if (!el) return
  el.classList.add('highlight-flash')
  window.setTimeout(() => {
    el.classList.remove('highlight-flash')
  }, 1200)
}

/**
 * Remove highlight span(s) from the DOM.
 * Prefer matching by Firestore doc id when available.
 * Falls back to removing the first .highlighted inside the paragraph.
 * @param {object} opts
 * @param {string=} opts.id          Firestore doc id (if you set data-highlight-id on span)
 * @param {string=} opts.paragraphID Host paragraph id
 */
export function unhighlight({ paragraphID, index, id } = {}) {
  // if you ever add per-span ids, prefer 'id'
  if (id) {
    const nodes = document.querySelectorAll(
      `[data-highlight-id="${CSS.escape(String(id))}"]`
    )
    nodes.forEach((span) => unwrapSpan(span))
    return
  }

  const root = document.getElementById(paragraphID)
  if (!root) return
  const spans = root.querySelectorAll('.highlighted')
  const target = spans && spans[index]
  if (target) unwrapSpan(target)
}

function unwrapSpan(span) {
  const parent = span.parentNode
  while (span.firstChild) parent.insertBefore(span.firstChild, span)
  parent.removeChild(span)
}
